import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { setGlobalLoading } from 'redux/actions/actionCommon'
import { deleteShipping, editShipping, getShippings } from 'utlis/Apis/Shipping_API'
import { SHIPPING_DELETED_SUCCESSFULLY } from 'utlis/AppMessages/AppMessages'
import { getError } from 'utlis/AppMessages/AppMessages'
import { CONFIRMATION_BEFORE_DELETING_SHIPPING } from 'utlis/AppMessages/AppMessages'
import { ERROR_WHILE_DELETING_SHIPPING } from 'utlis/AppMessages/AppMessages'
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages'
import { ERROR_WHILE_FETCHING_SHIPPINGS } from 'utlis/AppMessages/AppMessages'
import { SHIPPING_UPDATED_SUCCESSFULLY } from 'utlis/AppMessages/AppMessages'
import { ERROR_WHILE_CREATING_SHIPPING } from 'utlis/AppMessages/AppMessages'
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages'
import {
    conditionalShippingParams, customRateShippingParams, flatRateShippingParams, deleteExtra, freeShippingParams
} from './Pages/Shippings/Includes/Shipping/AddShipping/Helper'
import ShippingView from './Pages/Shippings/Includes/ShippingView'
import "./styles/shipping-styles.scss"

function Shippings(props) {
    const [loading, setLoading] = useState(true)
    const [shippings, setShippings] = useState([])

    useEffect(() => {
        setLoading(true)
        getShippings(props.currentUser.userToken).then(res => {
            setLoading(false)
            const resData = res.data
            window.scrollTo(0, 0)
            if (resData && resData.success) {
                setShippings(resData.data)
            }
            if (resData && resData.error) {
                toast.dismiss();

                toast.error(getError(resData.message, ERROR_WHILE_FETCHING_SHIPPINGS), {
                    autoClose: 3000
                })
            }
        })
            .catch(resData => {
                console.log(`${getError(resData.message)} getShipping`)
                toast.dismiss();
                toast.error(getError(resData.message, ERROR_WHILE_FETCHING_SHIPPINGS), {
                    autoClose: 2500,
                    onClose: () => {
                        setLoading(false)
                    }
                })
            })
    }, [props.currentUser.token, props])

    const deleteShipping_ = (id) => {
        var confirmation = window.confirm(CONFIRMATION_BEFORE_DELETING_SHIPPING)
        if (confirmation) {
            // setSectionLoadingVisible(true)
            setShippings(arr => [])
            const filterShippingList = shippings.filter(item => item.id !== id)
            setShippings(arr => [...filterShippingList])

            deleteShipping(props.currentUser.userToken, id).then(res => {
                // setSectionLoadingVisible(false)
                const deletedData = res.data
                if (deletedData.success) {
                    toast.dismiss();
                    toast.success(SHIPPING_DELETED_SUCCESSFULLY, {
                        autoClose: 2500,
                    })
                }

                if (deletedData.error) {
                    console.log(ERROR_WHILE_DELETING_SHIPPING, res)
                    toast.dismiss();

                    toast.error(ERROR_WHILE_DELETING_SHIPPING, {
                        autoClose: 2500,
                        onClose: () => {
                        }
                    })
                }

            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} deleteShipping `, err.message)
                toast.dismiss();
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // setSectionLoadingVisible(false)
                    }
                })
            })
        }
    }
    const addShipping_ = (shippings_) => {
        let params = {}
        if (shippings_.shipping_type === "free_shipping") {
            params = freeShippingParams(shippings_)
        } else if (shippings_.shipping_type === "conditional_free_shipping") {
            params = conditionalShippingParams(shippings_)
        } else if (shippings_.shipping_type === "flat_rate") {
            params = flatRateShippingParams(shippings_)
        } else {
            params = customRateShippingParams(shippings_)
        }
        params = deleteExtra(params)
        editShipping(props.currentUser.userToken, params).then(res => {
            setGlobalLoading(false)
            const shippingData = res.data
            if (shippingData.success) {
                // window.scrollTo(0, 0)
                toast.dismiss();
                // props.history.push('/my-sales/sale-orders', {
                //     shouldReload: true
                // })
                toast.success(SHIPPING_UPDATED_SUCCESSFULLY, {
                    autoClose: 2000,
                    onClose: () => { }
                })
            }
            if (shippingData.error) {
                console.log(ERROR_WHILE_CREATING_SHIPPING, res)
                toast.dismiss();
                toast.error(getError(shippingData.message, ERROR_WHILE_CREATING_SHIPPING), {
                    autoClose: 3000,
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} editShipping `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    setGlobalLoading(false)
                }
            })
        })
    }
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [props])

    return (
        <section id="app-shipping" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-product-filters">
                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Shipping, Delivery, and Pickup</p>
                    </div>
                    <ShippingView
                        loading={loading}
                        shippings={shippings}
                        addShipping_={addShipping_}
                        deleteShipping={(id) => deleteShipping_(id)}

                    />
                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(Shippings)